import { AuthController, AuthControllerImpl, Policy } from './auth-controller';
import React from 'react';

const authController: AuthController = new AuthControllerImpl();
const ServiceContext = React.createContext<{ authController: null | AuthController }>({ authController: null });

export type { Policy };
export { ServiceContext, authController };
